export class AdminMainController {
  constructor($scope, $rootScope, $location, UserService, AuthService) {
    $scope.vm = this;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.location = $location;
    this.UserService = UserService;
    this.AuthService = AuthService;
    this.scope.isAdmin = false;
    this.scope.isModerator = false;
    this.scope.locationPath = '';
    this.init();
  }

  init() {
    setTimeout(() => {
      // remove mm-foundation's handlers
      jQuery('.dropdown, .dropdown-toggle').off('click');
    }, 1000);

    this.scope.$watch(() => {
      return this.AuthService;
    }, (value) => {
      this.scope.isAdmin = value.isAdmin;
      this.scope.isModerator = value.isModerator;
    });

    this.scope.$watch(() => {
      return this.location.path();
    }, (value) => {
      this.scope.locationPath = value;
    });

    this.UserService.getCurrentUser()
      .then((response) => { let user = response.data;
        this.rootScope.currentUserProfile = user.data;
      })
      .catch((response) => { let err = response.data;
        console.log(err);
      });

    this.scope.reportModalOpen = () => {
      this.modal.open({
        templateUrl: 'reportModal.html',
        controller: 'ReportModalController'
      }).result.catch(angular.noop);
    };

    this.scope.logout = () => {
      this.AuthService.logout();
    };
  }
}
